import FuseNavigation from '@fuse/core/FuseNavigation';
import { BoosterNavBadges } from 'app/main/apps/booster/BoosterNavBadges';
import { CampaignNavBadge } from 'app/main/apps/communicationCampaign/reminder/CampaignNavBadge';
import VisibilityNavBadge from 'app/main/apps/visibility/components/shared/VisibilityNavBadge';
import { selectNavigationByFeature } from 'app/store/fuse/navigation.selector';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

interface NavigationProps {
  className?: string;
  dense?: boolean;
  active?: boolean;
}

function Navigation(props: NavigationProps) {
  const navigation = useSelector(selectNavigationByFeature);

  return (
    <>
      <VisibilityNavBadge />
      <BoosterNavBadges />
      <CampaignNavBadge />
      <FuseNavigation
        className={clsx('navigation', props.className)}
        navigation={navigation}
        dense={props.dense}
        active={props.active}
      />
    </>
  );
}

Navigation.defaultProps = {
  layout: 'vertical',
};

export default React.memo(Navigation);
